export const excludeTypes = {
  prohibit_letters: 'Letters',
  prohibit_numbers: 'Numbers',
  prohibit_spaces: 'Spaces',
  prohibit_symbols: 'Symbols',
} as const
